import "./App.scss";
import "bulma/css/bulma.css";
import {
  Route,
  Switch,
  useRouteMatch,
  useLocation,
  useHistory,
} from "react-router-dom";
import Header from "./commonComponents/Header";
import Home from "./AppComponents/Home";
import Games from "./AppComponents/Games";
import Game from "./AppComponents/Game";
import Subscribe from "./AppComponents/Subscribe";
import FreeGames from "./AppComponents/FreeGames";
import Mobile from "./AppComponents/Mobile";
import OTP from "./AppComponents/OTP";
import NotFound from "./AppComponents/NotFound";
import queryString from "query-string";
import React, { useEffect } from "react";
import config from "./config";
import _ from "lodash";
import { reactLocalStorage } from "reactjs-localstorage";
import ReactGA from "react-ga";
import RouteChangeTracker from "./RouteChangeTracker";
import Subcription from "./hooks/Subscription";
import TagManager from 'react-gtm-module';

function App() {
  const match1 = useRouteMatch("/game/:id");
  const match2 = useRouteMatch("/freegames");
  const history = useHistory();
  console.log(">>>route match:::", match1, match2);
  let location = useLocation();
  let params = queryString.parse(location.search);
  const { allowUser, checkSubcription } = Subcription();

  useEffect(() => {
    const subStatus = reactLocalStorage.getObject("subcription");
    const uidLocal = reactLocalStorage.get("uid");
    if (params && _.has(params, "uid")) {
      reactLocalStorage.set("uid", params.uid);
      checkSubcription(params.uid);
    } else {
      if (uidLocal !== "" && _.isEmpty(subStatus) === false) {
       // allowUser(subStatus, uidLocal);
        checkSubcription(uidLocal);
      } else if (uidLocal !== "" && _.isEmpty(subStatus) === true) {
        checkSubcription(uidLocal);
      } else {
        window.location.href = config.get("base") + config.get("error");
      }
    }
  }, [params]);

  // useEffect(() => {
  //   ReactGA.initialize("UA-120007411-1", { debug: false });
  // }, []);

const tagManagerArgs = {
    gtmId: 'GTM-MH39TC3',
    debug: true
};
TagManager.initialize(tagManagerArgs)
// useEffect(() => {
//   ReactGA.initialize("G-93D2EH65BN", { debug: true });
// }, []);

  return (
    <section className="hero is-fullheight bg">
      {!(match1 || match2) && <Header />}
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/subcribe">
          <Subscribe />
        </Route>
        <Route path="/games">
          <Games />
        </Route>
        <Route path="/game/:id">
          <Game />
        </Route>
        <Route path="/freegames">
          <FreeGames />
        </Route>
        <Route path="/mobile">
          <Mobile />
        </Route>
        <Route path="/otp">
          <OTP />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
      <RouteChangeTracker history={history} />
    </section>
  );
}

export default App;
